import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _RequestConfig;
import { initRequest, ENV_MAP } from "@alipay/rewards-common-tools";
import { showToast } from "./toast";
var RequestConfig = (_RequestConfig = {}, _defineProperty(_RequestConfig, ENV_MAP.LOCAL, {
  baseUrl: "http://127.0.0.1:7001/api/proxy",
  mockAuth: "true",
  "sofa-group-name": "GROUP_20230825103447",
  workspaceId: "default"
}), _defineProperty(_RequestConfig, ENV_MAP.DEV, {
  mockAuth: "true",
  "sofa-group-name": "GROUP_20230825103447",
  baseUrl: "http://imgs-1.sggz00b.stable.alipay.net/imgw.htm",
  workspaceId: "default"
}), _defineProperty(_RequestConfig, ENV_MAP.PRE, {
  baseUrl: "https://imgs-sea-pre.alipay.com/imgw.htm",
  workspaceId: "pre"
}), _defineProperty(_RequestConfig, ENV_MAP.PROD, {
  baseUrl: "https://imgs-sea.alipay.com/imgw.htm",
  workspaceId: "default"
}), _defineProperty(_RequestConfig, "handleFail", function handleFail(message) {
  showToast(message);
}), _RequestConfig);
export var requestInit = function requestInit() {
  initRequest(RequestConfig);
};
